<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <span class="new-signup-user"
                                >Please provide parent details here</span
                            >
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field
                                v-model="name"
                                label="Parent Name"
                                hide-details
                                dense
                                outlined
                            ></v-text-field>
                            <InputError :data="error.name" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field
                                v-model="email"
                                label="Parent Email ID"
                                hide-details
                                dense
                                outlined
                            ></v-text-field>
                            <InputError :data="error.email" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary sign-up-terms top-0">
                                <div class="user-new-signup">
                                    <div class="user-terms-block" v-if="showPrivacyAndTerms">
                                        <div class="user-terms-check">
                                            <v-checkbox
                                                input-value=""
                                                value
                                                v-model="ischecked"
                                            ></v-checkbox>
                                        </div>
                                        <div class="user-terms-text-outer">
                                            <div class="user-terms-text">
                                                I accept the
                                                <a @click="termandcondition"
                                                    >Terms of Service</a
                                                >
                                                and
                                                <a @click="privacyPolicy"
                                                    >Privacy Policy</a
                                                >
                                            </div>
                                        </div>
                                        <InputError :data="error.ischecked" />
                                    </div>
                                </div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="onSubmit"
                                        class="right-btn cust-btn"
                                        color="primary"
                                        >Done</v-btn
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute &&myInstitute &&  !myInstitute.is_white_labeled" class="power-logo">
                    <img
                        src="@/assets/img/logo-footer.png"
                        class="master-logo"
                    />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "SignUpNewParent",
    data() {
        return {
            name: "",
            email: "",
            logo: this.getInstituteLogo(),
            ischecked: false,
            error: {
                name: {
                    type: null,
                    message: "Please enter name",
                },
                email: {
                    type: null,
                    message: null,
                },
                ischecked: {
                    type: null,
                    message:
                        "Please accept Terms & Conditions and Privacy Policy",
                },
            },
			showPrivacyAndTerms:true
        };
    },
    methods: {
        ...mapActions({
            signUp: "userStore/signUp",
        }),
        onSubmit() {
            if (this.validate()) {
                this.$root.showLoader = true;
                let details = null;
                if (this.name && this.email) {
                    details = {
                        name: this.name.trim(),
                        email: this.email.trim(),
                    };
                }
				delete this.signUpStudentData['center_id']
                this.signUp({
                    ...this.signUpData,
                    ...this.signUpStudentData,
                    details,
                })
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.$toasted.success(`Success\n${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },
        validate() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            if (!this.name || this.name.trim().length < 1) {
                this.error.name.type = "error";
                this.error.name.message = "Please enter name";
                isValid = false;
            }
            if (!this.email || this.email.length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.email)) {
                this.error.email.type = "error";
                this.error.email.message =
                    "The email ID entered by you is not a valid email ID. Please enter a valid email ID.";
                isValid = false;
            } else if (this.email===this.signUpData.email) {

                    this.error.email.type = 'error';
                    this.error.email.message = 'The email IDs for the student and the parent cannot be the same.';
                    isValid = false;
                }
            if (!this.ischecked && this.showPrivacyAndTerms) {
                this.error.ischecked.type = "error";
                isValid = false;
            }
            // }
            return isValid;
        },
        termandcondition() {
            let routeData = this.$router.resolve({
                name: "terms-and-conditions",
            });
            window.open(routeData.href, "_blank");
        },
        privacyPolicy() {
            let routeData = this.$router.resolve({ name: "privacy-policy" });
            window.open(routeData.href, "_blank");
        },
    },
    computed: {
        ...mapState("userStore", [
            "signUpData",
            "signUpStudentData",
            "isDefaultInstitute",
            'myInstitute'
        ]),
    },
    mounted() {
		 const instiute = JSON.parse(localStorage.getItem('myInstitute'));
	  this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)
        if (!this.signUpStudentData) {
            this.$router.push({ name: "student-signup-step2" });
        }
    },
    watch: {
        ischecked() {
            this.error.ischecked.type = null;
        },
    },
};
</script>
